import { useDispatch, useSelector } from 'react-redux';
import { IWorksheetComponent } from '../../../../Core/types';
import { NamePrefixModifier, withInjectedProps } from '../../../../../Core/InjectedPropsContext';
import { pipe } from 'Lib/Hooks/Selectors';
import { valueOrDefault } from 'Lib/Any';
import { Button, ConfirmDialog } from '../../../../../Core';
import deepEquals from 'Lib/Object/deepEquals';
import { actions } from 'Data/ReduxViewModels/WorksheetEditor';
import { ascend, sort } from 'ramda';
import { PageSection } from 'Components/Layout';
import { LoadIncrement } from '../../../types';
import { LoadIncrementDetailsSection } from '..';
import { LoadIncrementReadingsGridSection } from 'Components/Worksheets/PlateLoadingWorksheet/Sections';

let LoadIncrementsSectionBase = ({ createWorksheetSelector, namePrefix }: IWorksheetComponent): JSX.Element => {
  const dispatch = useDispatch();

  const loadIncrements: any[] = useSelector(
    pipe(createWorksheetSelector!('LoadIncrements'), valueOrDefault([]), (records: LoadIncrement[]) => {
      return sort(
        ascend((r: LoadIncrement) => Number(r.IncrementIndex)),
        records.map((record, index) => ({
          ...record,
          index,
        }))
      );
    }),
    deepEquals
  );

  const addIncrements = (index: number = 0) => (
    <Button
      onClick={() => {
        dispatch(
          actions.addArrayEntry({
            name: `${namePrefix}.LoadIncrements`,
            index: index,
            data: { IncrementIndex: index },
            sync: true,
          })
        );
      }}
    >
      Add Increment
    </Button>
  );

  return (
    <>
      {loadIncrements &&
        loadIncrements.length > 0 &&
        loadIncrements.map((r, index) => (
          <PageSection key={`Increment${index + 1}`} heading={`Load Increment ${r.IncrementIndex + 1}`}>
            <NamePrefixModifier appendNamePrefix={`LoadIncrements[${r.index}]`}>
              <LoadIncrementDetailsSection />
              <LoadIncrementReadingsGridSection />
              <div>
                <ConfirmDialog
                  confirm={true}
                  confirmText={`Are you sure you want to remove load increment ${
                    r.IncrementIndex + 1
                  }? Data entered for this load increment will be lost.`}
                  confirmButtonText="Remove Increment"
                  confirmTitle={`Remove Load Increment ${r.IncrementIndex + 1}`}
                >
                  <Button
                    error
                    onClick={() => {
                      dispatch(
                        actions.removeArrayEntry({
                          name: `${namePrefix}.LoadIncrements`,
                          index: r.index,
                          sync: true,
                        })
                      );
                    }}
                  >
                    Remove Increment
                  </Button>
                </ConfirmDialog>
                {addIncrements(index + 1)}
              </div>
            </NamePrefixModifier>
          </PageSection>
        ))}
    </>
  );
};

const LoadIncrementsSection = withInjectedProps(LoadIncrementsSectionBase);
export { LoadIncrementsSection };
export default LoadIncrementsSection;
